/**
 * Aura 플랫폼 기반 Work 사례·후기 (표시용 샘플)
 * kind: 'project' | 'review'
 * detailParagraphs: 상세 글(/work/:id) 진행·결과 본문 (여러 문단)
 */
export const AURA_PORTFOLIO_ITEMS = [
  {
    id: '1',
    kind: 'project',
    tag: '전시',
    title: '갤러리 상설전 — WebAR 도슨트',
    date: '2025.11',
    image: '/image/gallery.png',
    excerpt: 'Aura로 이미지 마커·영상·링크를 구성, 방문객이 앱 없이 작품 설명을 경험했습니다.',
    detailParagraphs: [
      '기획 단계에서 작품별 마커 이미지와 오버레이 콘텐츠를 Aura 통합 운영 화면에 등록했습니다.',
      '전시 오픈 전 QR을 인쇄물·안내판에 배치하고, 현장 네트워크 환경에서 WebAR 로딩을 점검했습니다.',
      '개막 후에는 체류·스캔 데이터로 인기 작품을 파악해 도슨트 순서와 안내 문구를 조정했습니다.',
    ],
  },
  {
    id: '2',
    kind: 'review',
    tag: '후기',
    title: '독립 큐레이터 A',
    date: '2025.10',
    image: '/image/artist.png',
    excerpt:
      '“콘텐츠 수정이 빨라져 전시 기간 중에도 문구를 바로 반영할 수 있었습니다. 운영 부담이 확 줄었어요.”',
    detailParagraphs: [
      '처음에는 외주 제작으로만 WebAR을 검토했으나, 수정마다 일정·비용이 커지는 점이 부담이었습니다.',
      'Aura 도입 후에는 직접 운영 화면에서 문구·영상을 바꿀 수 있어, 오프닝 이후 피드백을 빠르게 반영했습니다.',
      '방문객에게 “앱 설치 없이 카메라만으로 된다”는 안내가 가능해져 문의 전화도 줄었습니다.',
    ],
  },
  {
    id: '3',
    kind: 'project',
    tag: '팝업',
    title: '브랜드 팝업 — QR WebAR 체험',
    date: '2025.08',
    image: '/image/brand.png',
    excerpt: '현장 QR만으로 WebAR 실행, 체류 데이터로 존을 조정한 사례입니다.',
    detailParagraphs: [
      '팝업 동선에 맞춰 존별 프로젝트를 나누고, 각 존에 고정 QR을 배치했습니다.',
      'Aura 분석에서 체류가 길었던 포인트를 확인해 다음 주 전시물 배치를 조정했습니다.',
      '캠페인 종료 후에도 링크를 유지해 온라인 리콜용으로 재사용할 수 있었습니다.',
    ],
  },
  {
    id: '4',
    kind: 'review',
    tag: '후기',
    title: '공간 운영 매니저 B',
    date: '2025.07',
    image: '/image/page2.png',
    excerpt:
      '“별도 앱 배포 없이 안내할 수 있어 현장 스태프 교육도 단순했습니다. 방문 질문도 줄었습니다.”',
    detailParagraphs: [
      '기존에는 태블릿 앱 설치와 계정 관리로 오프닝 전 스태프 교육이 길었습니다.',
      'WebAR 전환 후에는 QR 스캔 안내만 익히면 되어 교육 시간이 단축되었습니다.',
      '현장에서 “앱 어디 받나요?” 유형의 문의가 줄고, 안내 인력을 다른 동선에 배치할 수 있었습니다.',
    ],
  },
  {
    id: '5',
    kind: 'project',
    tag: '아트페어',
    title: '부스 연계 — 작가 스토리 WebAR',
    date: '2025.05',
    image: '/image/page3.png',
    excerpt: '부스별 프로젝트를 Aura에 묶어 QR 안내로 통합 운영했습니다.',
    detailParagraphs: [
      '참가 갤러리마다 부스 코드를 나눠 프로젝트를 생성하고, 통일된 비주얼 가이드로 마커를 제작했습니다.',
      '페어 기간 중 원데이 이벤트마다 콘텐츠만 교체해 같은 QR로 다른 스토리를 노출했습니다.',
      '종료 후 갤러리별 리포트를 내려받아 다음 행사 제안에 활용했습니다.',
    ],
  },
  {
    id: '6',
    kind: 'review',
    tag: '후기',
    title: '기획사 담당자 C',
    date: '2025.04',
    image: '/image/gallery.png',
    excerpt:
      '“운영 화면에서 마커·에셋만 갈아 끼우면 되니, 클라이언트 수정 요청에도 대응이 빨랐습니다.”',
    detailParagraphs: [
      '클라이언트 측 디자인 수정이 잦은 캠페인이었고, 빌드 없이 교체 가능한 구조가 필요했습니다.',
      'Aura에서 3D·영상 에셋을 버전별로 올려 두고, 승인된 것만 공개 전환하는 흐름으로 맞췄습니다.',
      '덕분에 야간 승인 이후에도 다음 날 오전 오픈 전 반영이 가능했습니다.',
    ],
  },
];
